import { ApiTypes } from '../../types';
export var Anonymous = {
    imageUrl: null,
    joinedOn: null,
    name: { nick: null },
    relationship: ApiTypes.v1.RelationshipWithGroup.NONE,
    requestedMembershipOn: null,
    roles: [],
    siteMemberId: null,
};
export var MembersQueryInitialResponse = {
    query: undefined,
    members: [],
};
//# sourceMappingURL=Member.js.map